
function addPrefix(prefix: string, className: string[]): string {
  return className.map(oneClass => `${prefix}${oneClass.trim()}`).join(' ');
}

export {
  addPrefix,
};
